import { ImgHTMLAttributes, useState, useEffect, SyntheticEvent } from "react";

interface NativeImageProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'onLoad'> {
    fallback?: string;
    onImageLoad?: (event?: SyntheticEvent) => void;
}
const Image: React.FC<NativeImageProps> = ({ fallback, onImageLoad, ...props }) => {
    const [imgSrc, setImgSrc] = useState(props.src ?? '/Images/no-image.jpg');

    useEffect(() => {
        setImgSrc(props.src ?? '/Images/no-image.jpg');
    }, [props.src]);

    const handleError = () => {
        fallback = fallback ?? '/Images/no-image.jpg';
        if (imgSrc != fallback) {
            setImgSrc(fallback);
            onImageLoad && onImageLoad();
        }
    };

    const handleImageLoad = (event: SyntheticEvent) => {
        onImageLoad && onImageLoad(event);
    }

    return <img {...props} src={imgSrc} onError={handleError} onLoad={handleImageLoad} />
}

export default Image;